import { NameValueDropdown } from "src/app/settings/models/nameValueDropdown";

export const FILTERTYPE: NameValueDropdown[] = [
    { name: 'All Customers', value: 'all' },
    { name: 'Mapped', value: 'mapped' },
    { name: 'Not Mapped', value: 'notmapped' }
]